module.exports = __webpack_public_path__ + "static/media/tour-1.e8d7f146.png";